export const Colors = {
  White: '#FFFFFF',
  Black: '#000000',
  DarkGray: '#111827', // tailwind default gray-900
  LightGray: '#f9fafb', // tailwind default gray-50
  Gray200: '#e5e9eb', // tailwind gray-200
  Gray400: '#A0A0A0', // tailwind gray-400
};
